import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import { useNavigate } from 'react-router-dom';
import { compose } from 'redux'; // Import compose from redux
import Logger from '../../../../util/Logger';
import * as jobActions from '../../../../actions/jobActions';
import { containerTreatmentResultRecordsForm } from '../../../../constants/FormConstants';
import { withSortedReadings, withCalculatedFields } from './containerEnhancers';
import ContainerTreatmentResultRecordsForm from './ContainerTreatmentResultRecordsForm';
import actions from 'redux-form/lib/actions';

const ContainerTreatmentResultRecordsContainer = ({ currentTreatmentResultRecord }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Dispatch actions for job actions
  const actions = {
    ...jobActions,
    changeFieldValue: (field, value) => dispatch(change(containerTreatmentResultRecordsForm, field, value)),
  };

 return (
    <ContainerTreatmentResultRecordsForm
      initialValues={currentTreatmentResultRecord}
      actions={actions}
      navigate={navigate}
    />
  ); 
};

const mapStateToProps = (state) => ({
  // Add any state props here if needed

});

const enhance = compose(
  connect(mapStateToProps),
  withSortedReadings,
  withCalculatedFields,
);

export default enhance(
  reduxForm({
    form: containerTreatmentResultRecordsForm,
    enableReinitialize: true,
    onSubmitFail: (errors, dispatch, submitError) => {
      Logger.error(
        'We were unable to save the changes, please review the fields in red and try again.',
        submitError,
        'Log Row Record not saved',
      );
    },
  })(ContainerTreatmentResultRecordsContainer)
);
